export default {
  props: {
    familyName: {
      type: String,
      required: true
    },
    src: {
      type: String,
      required: true
    }
  },
  setup(props) {
    return props
  }
}
